import React from 'react';
import { pick } from 'ramda';
import { AUTH_REDUCER } from 'js/store/constants';
import { useCustomSelector } from 'js/store/hooks';
import { Loader } from 'js/components/common/Loader';
import { ManagedPopup } from 'js/components/common/Popup';
import { useCombinedHandler } from 'js/hooks/useCombinedHandler';
import { useOnClose } from 'js/components/common/PopupManager/hooks';
import { useSubscribeOnLocationChange } from 'js/hooks/useSubscribeOnLocationChange';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';
import BonusMultiviewPageView from 'js/components/main/BonusMultiview/components/BonusMultiViewPageView/BonusMultiViewPageView';

import * as hooks from './hooks';

import style from './BonusMultiviewBonusDetailsPopup.scss';

export const BonusMultiviewBonusDetailsPopup = ({ id, bonus }) => {
    const onClosePopup = useOnClose(id);
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();
    const combinedClose = useCombinedHandler([onClosePopup, navigateToPopupBackgroundPage]);
    const { isLoginInProcess, isLogoutInProcess } = useCustomSelector(AUTH_REDUCER, pick(['isLoginInProcess', 'isLogoutInProcess']));
    const portletConfig = {
        portletType: 'bonus-multi-view',
        config: {
            bonusId: bonus.bonusCode,
            viewType: 'pageView'
        },
        showBorders: true
    };

    hooks.useCloseOnLogout(combinedClose);
    useSubscribeOnLocationChange(onClosePopup);
    hooks.useLegacyBonusDetailsPopupCloseListener(combinedClose);

    return (
        <ManagedPopup
            layerClassNames={style}
            onClose={combinedClose}
            className="detailed-bonus-popup fn-bonus-details-popup"
        >
            {isLoginInProcess || isLogoutInProcess
                ? <Loader className={style.loader} />
                : <BonusMultiviewPageView config={portletConfig} />
            }
        </ManagedPopup>
    );
};
